import { useMemo, useState } from "react";
import { SelectableOptionMenuItemType } from "@fluentui/react";

// Type-to-filter for a Fluent multiSelect ComboBox: returns the options to render plus the
// input/dismiss handlers to spread onto the ComboBox.
// Non-matching options are hidden (not removed) because the ComboBox tracks options by
// index, so keeping the array intact keeps selections and keyboard navigation correct.
// `hidden` is mirrored into `data` because Fluent memoizes each option row on
// index/text/checked/data only - without a changed `data` the row never re-renders.
const useTypeToFilterOptions = (sourceOptions, noMatchText) => {
  const [searchText, setSearchText] = useState("");

  const options = useMemo(() => {
    const allOptions = sourceOptions || [];
    const search = searchText.trim().toLowerCase();
    if (!search) return allOptions;
    const filtered = allOptions.map((option) => {
      const hidden = !String(option.text).toLowerCase().includes(search);
      return { ...option, hidden, data: { ...option.data, hidden } };
    });
    if (filtered.every((option) => option.hidden)) {
      filtered.push({
        key: "__no_matching_options__",
        text: noMatchText,
        itemType: SelectableOptionMenuItemType.Header,
      });
    }
    return filtered;
  }, [sourceOptions, searchText, noMatchText]);

  const filterProps = {
    onInputValueChange: (value) => setSearchText(value || ""),
    onMenuDismissed: () => setSearchText(""),
  };

  return [options, filterProps];
};

export default useTypeToFilterOptions;
